import { Howl } from 'howler';
import sprite from '../sound/0-100/0-100-sprite.json';
import numbersSrcOgg from '../sound/0-100/0-100-sprite.ogg';
import numbersSrcM4a from '../sound/0-100/0-100-sprite.m4a';

const numberSounds = new Howl({
  src: [numbersSrcOgg, numbersSrcM4a],
  sprite: sprite.sprite,
});

export default numberSounds;



// WEBPACK FOOTER //
// ./src/js/number-sounds.js